import React, { useState, useEffect } from 'react';
import { profileImageUrl, profileFallbackColor } from '../lib/profileImage';

/**
 * Circular profile image. Source priority:
 *   1. `src`   — an explicit URL / base64 data URL (the saved profile image)
 *   2. `index` — a profile index 0~49 -> /assets/profiles/{index}.png
 *   3. fallback colored disc (hue from the index)
 * Sizing/border come from `className` + `style`.
 */
export default function ProfileImage({ index, src, className = '', style, alt = 'profile' }) {
  const [srcFailed, setSrcFailed] = useState(false);
  const [idxFailed, setIdxFailed] = useState(false);

  useEffect(() => {
    setSrcFailed(false);
    setIdxFailed(false);
  }, [index, src]);

  if (src && !srcFailed) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
        style={style}
        onError={() => setSrcFailed(true)}
        draggable={false}
      />
    );
  }

  if (index != null && !idxFailed) {
    return (
      <img
        src={profileImageUrl(index)}
        alt={alt}
        className={className}
        style={style}
        onError={() => setIdxFailed(true)}
        draggable={false}
      />
    );
  }

  return (
    <div
      className={className}
      style={{ ...style, backgroundColor: profileFallbackColor(index || 0) }}
      aria-label={alt}
    />
  );
}
